module.exports = __webpack_public_path__ + "img/11.8bb07b58.jpg";